import React from "react";
import { PropertyDetailsProvider, type PropertyDetailsContextValue } from "./contexts/property-details-context.tsx";
import { PropertyDetailsScreen } from "./property-details-page.tsx";
import { WatchlistProvider } from "./contexts/watchlist-context.tsx";
import { WatchlistModal } from "./watchlist-modal.tsx";
import { AdConfigProvider } from "./contexts/ad-config-context.tsx";

export type PropertyDetailsScreenProps = PropertyDetailsContextValue;

export const PropertyDetailsPageScreen: React.FC<PropertyDetailsScreenProps> = (contextValue) => {
  return (
    <PropertyDetailsProvider value={contextValue}>
      <WatchlistProvider value={{ isWatchlisted: contextValue.isWatchlisted }}>
        <AdConfigProvider targeting={contextValue.adTargeting}>
          <WatchlistModal />
          <PropertyDetailsScreen />
        </AdConfigProvider>
      </WatchlistProvider>
    </PropertyDetailsProvider>
  );
};
